// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1GdZ7","list":"BalanceDue_list__3xcoG","listRow":"BalanceDue_listRow__563Ev","total":"BalanceDue_total__2WH3e"};